import { Player } from '@lottiefiles/react-lottie-player'
import moment from 'moment'
import { memo, useMemo, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useShallow } from 'zustand/react/shallow'
import { useGetGamesBoxesRooms } from '../../../../hooks/queries/games/games-boxes-rooms/use-get-games-boxes-rooms'
import { useUpdateGameBoxRoom } from '../../../../hooks/queries/games/games-boxes-rooms/use-update-game-box-room'
import { useSub } from '../../../../hooks/subscription/use-sub'
import type { GameBoxRoom } from '../../../../services/games/games-boxes-rooms/types'
import { useGlobalStore } from '../../../../store/global-store'
import gift from '../assets/gift-animated.json'
import { useCheckExpiredCoinDrop } from '../use-check-expired-coin-drop'
import { Timer } from './timer'
import { useGetGameEnabledFirst } from '../../../../hooks/queries/games/games-enableds/use-get-game-enabled-first.ts'

const COIN_DROP = '/COIN-DROP'

function CoinDrop({ gameBoxRoom }: { gameBoxRoom: GameBoxRoom }) {
  const [shouldHide, setShouldHide] = useState(false)

  const {
    allowRescue,
    setShouldAllowRescue,
    //
  } = useCheckExpiredCoinDrop(gameBoxRoom)

  const { gameEnabled } = useGetGameEnabledFirst()
  const { update } = useUpdateGameBoxRoom()

  const rescueTime = useMemo(() => {
    return moment(gameBoxRoom?.dateLimitToRescue).format('YYYY-MM-DD HH:mm:ss')
  }, [gameBoxRoom?.dateLimitToRescue])

  function openModalCoinDrop(gameBoxRoomId: number) {
    if ('ReactNativeWebView' in window) {
      // @ts-ignore
      window.ReactNativeWebView.postMessage(gameBoxRoomId)
    }
  }

  function handleRemoveFromList() {
    update({ gameBoxRoomId: gameBoxRoom?.id, closed: true })
    setShouldHide(true)
  }

  if (shouldHide) {
    return null
  }

  if (!gameEnabled?.enableGameBoxRoom) {
    return null
  }

  return (
    <div
      className="flex flex-col items-center justify-center relative h-full w-full"
      onClick={() => openModalCoinDrop(gameBoxRoom.id)}
    >
      <Player loop autoplay src={gift} className="h-full w-full " />

      <div className="w-4 h-4 absolute top-1/2 left-1/2">
        <img
          src={gameBoxRoom.user.imgUser}
          className="w-4 h-4 relative -mt-1.5 -left-1/2 rounded-full"
        />
      </div>

      {allowRescue && (
        <div className="absolute bottom-0">
          <Timer timeToEnd={rescueTime} onFinish={handleRemoveFromList} />
        </div>
      )}

      {gameBoxRoom.dateFinalDistribute && !allowRescue && (
        <div className="absolute bottom-0">
          <Timer
            timeToEnd={gameBoxRoom.dateFinalDistribute}
            onFinish={() => setShouldAllowRescue(true)}
          />
        </div>
      )}
    </div>
  )
}

export const GameBox = memo(() => {
  const { liveId } = useGlobalStore(
    useShallow((state) => ({
      liveId: state.liveId,
    })),
  )

  console.log('Rendering GameBox with liveId:', liveId)

  const { gamesBoxesRooms, refetch } = useGetGamesBoxesRooms({
    liveId: liveId!,
  })

  useSub<GameBoxRoom>({
    endpoint: `${COIN_DROP}/${liveId}`,
    skip: !liveId,
    onData: () => {
      refetch()
    },
  })

  return (
    <div className="w-screen h-screen flex">
      <Swiper
        key={gamesBoxesRooms?.length}
        slidesPerView={1}
        className="flex flex-row h-full w-full"
      >
        {gamesBoxesRooms?.filter(Boolean).map((gameBoxRoom) => (
          <SwiperSlide
            key={gameBoxRoom.id}
            className="h-full w-full flex flex-col items-center justify-center"
          >
            <CoinDrop gameBoxRoom={gameBoxRoom} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
})
